import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TRANSFERHISTORY,
  DELETE_TRANSFERHISTORY,
  UPDATE_TRANSFERHISTORY,
  ADD_NEW_TRANSFERHISTORY,
} from "./actionType";

import {
  getTransferHistorySuccess,
  getTransferHistoryFail,
  deleteTransferHistorySuccess,
  deleteTransferHistoryFail,
  updateTransferHistorySuccess,
  updateTransferHistoryFail,
  addTransferHistorySuccess,
  addTransferHistoryFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveTransferHistoryApi,
  getTransferHistoryApi,
  updateTransferHistoryApi,
  deleteTransferHistoryApi,
  addNewTransferHistoryApi
} from "../../helpers/backend_helper";

function* getTransferHistory({ payload: transferHistory }) {
  try {
    const response = yield call(getTransferHistoryApi, transferHistory);
    yield put(getTransferHistorySuccess(GET_TRANSFERHISTORY, response.data));
  } catch (error) {
    yield put(getTransferHistoryFail(GET_TRANSFERHISTORY, error));
  }
}

function* onUpdateTransferHistory({ payload: transferHistory }) {
  try {
    if (transferHistory.setApprove) {
      const response = yield call(approveTransferHistoryApi, transferHistory);
      yield put(updateTransferHistorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateTransferHistoryApi, transferHistory);
      yield put(updateTransferHistorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTransferHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTransferHistory({ payload: transferHistory }) {
  try {
    const response = yield call(deleteTransferHistoryApi, transferHistory);
    yield put(deleteTransferHistorySuccess({ transferHistory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTransferHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTransferHistory({ payload: transferHistory }) {
  try {
    const response = yield call(addNewTransferHistoryApi, transferHistory);
    yield put(addTransferHistorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTransferHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTransferHistory() {
  yield takeEvery(GET_TRANSFERHISTORY, getTransferHistory);
}

export function* watchUpdateTransferHistory() {
  yield takeEvery(UPDATE_TRANSFERHISTORY, onUpdateTransferHistory);
}

export function* watchDeleteTransferHistory() {
  yield takeEvery(DELETE_TRANSFERHISTORY, onDeleteTransferHistory);
}

export function* watchAddNewTransferHistory() {
  yield takeEvery(ADD_NEW_TRANSFERHISTORY, onAddNewTransferHistory);
}

function* transferHistorySaga() {
  yield all([
    fork(watchGetTransferHistory),
    fork(watchDeleteTransferHistory),
    fork(watchUpdateTransferHistory),
    fork(watchAddNewTransferHistory)
  ]);
}

export default transferHistorySaga;
